import { useEffect } from 'react'
import { SetURLSearchParams } from 'react-router-dom'

export const useStartParamsDish = (setSearchParams: SetURLSearchParams) => {
  useEffect(() => {
    setSearchParams((sp) => {
      sp.set('archived', '0')
      return sp
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
